const publicCN = {
    SEARCH: '搜索',
    COMPANY_SEARCH: '公司搜索',
    PERSON_SEARCH: '公司详情',
    PERSON:'联系人',
    REGISTER:'注册',
    REGISTER_SUCCEED:'注册成功',
    SEND_SUCCEED:'发送成功！',
    SEND_FAILED:'发送失败！稍后请重试！',
    MAIL_AL_REGISTER:'此邮箱已经注册',
    LOGIN_AND_REG:'登录（注册）',
    LOGIN:'登录',
    PLS_INPUT_PWD:'请输入密码',
    PLS_INPUT_EMAIL:'请输入邮箱',
    PLS_INPUT_RIGHT_EMAIL:'请输入正确的邮箱',
    PLS_INPUT_VALIDATE_CODE:'请输入验证码',
    PLS_INPUT_COMPANY:'请输入公司',
    COMPANY:'公司',
    CONTACT:'联系人',
    SEARCH_SENTENSE1:'六千万量级企业库支撑',
    COMPANIES:'公司',
    CONTACTS:'联系人',
    SEARCH_EMAIL:'直达邮箱',
    SEARCH_PHONE:'联系人电话',
    SEARCH_SENTENSE2:'请输入英文公司名，产品关键词',
    SEARCH_SENTENSE3:'请输入英文公司名',
    SEARCH_SENTENSE4:'搜索词不能为空',
    SEARCH_SENTENSE5:'获取你下一个客户，直达邮箱、手机等联系方式',
    NAME:'姓名',
    CHINESE:'中文',
    ENGLISH:'英文',
    COLLECT:'加入收藏夹',
    CLEAR:'清除',
    KEYWORD:'关键词',
    COUNTRY:'国家',
    INDUSTRY:'行业',
    REVENUE:'营业额',
    EMPLOYEE:'雇员数量',
    EMPLOYEE_U:'雇员数量',
    RESULT:'搜索结果',
    SELECTALL:'全选',
    EXPORT:'导出',
    SORTBY:'排序',
    SUMMARY:'概览',
    NEWS:'新闻',
    SOCIAL:'社交',
    TRADERECORD:'交易记录',
    WEBSITE:'网站',
    TYPE:'公司类型',
    EMPLOYEES:'公司规模',
    ESTABLISHED:'创立时间',
    PHONE:'电话',
    FAX:'传真',
    ADDRESS:'地址',
    CONTACT_LEVEL:'联系人级别',
    CONTACT_ROLE:'联系人岗位',
    LEVEL_ROLE:'级别与岗位',
    CONTACT_WAY:'联系方式',
    MANAGE:'操作',
    CHECK:'查看',
    CHECKED:'已查看',
    SOCIAL_INFO:'社交信息',
    JOB_TITLE:'职位',
    MY:'我的',
    AND:'与',
    ALL:'所有',
    ENTER_A_KEYWORD:'请输入关键词',
    SELECT_A_LOCATION:'选择地区',
    SELECT_A_INDUSTRY:'选择行业',
    ENTER_A_COMPANY:'请输入公司',
    ENTER_A_NAME:'请输入姓名',
    SELECT_A_JOB_LEVEL:'选择级别',
    SELECT_A_JOB_FUNCTION:'选择岗位',
    EMAIL_ADDRESS:'邮箱',
    IDENTIFY_CODE:'验证码',
    SEARCH_SENTENSE6:'请输入密码',
    SEARCH_SENTENSE7:'请输入邮箱',
    SEARCH_SENTENSE8:'请输入地址',
    SEARCH_SENTENSE9:'请输入公司',
    SEARCH_SENTENSE10:'请输入验证码',

}
export default publicCN


// WEBPACK FOOTER //
// ./src/lan/cn/cn_public.js